// This loads the communitylocation data from the database based off
// the locations sent in.
import { useState, useEffect } from "react";
import useFirestore from "./useFirestore";

export default function useCommunityLocations(communityLocationNames) {
  const database = useFirestore();
  const [error, setError] = useState();
  // false if done loading and true if currently loading
  const [loading, setLoading] = useState(false);
  // Stores all the Data
  const [locationData, setLocationData] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    setLocationData([]);
    // If no locations were sent it and the array is empty skip.
    if (!communityLocationNames.length) {
      setLoading(false);
      return;
    }
    // We have to load in chunks as we can only specify the where for
    // a max of 10.
    const allResults = [];
    const chunks = [];

    // Firestore only allows 10 values in "in" queries
    for (let i = 0; i < communityLocationNames.length; i += 10) {
      chunks.push(communityLocationNames.slice(i, i + 10));
    }

    let completedChunks = 0;

    chunks.forEach((chunk) => {
      database
        .collection("CommunityLocations")
        .where("locationName", "in", chunk)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.exists) {
              allResults.push({ id: doc.id, ...doc.data() });
            }
          });

          completedChunks++;
          if (completedChunks === chunks.length) {
            setLocationData(allResults);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.error("Error fetching community locations:", err);
          setError(err);
          setLoading(false);
        });
    });
  }, []);

  return { locationData, loading, error };
}
